import { computed } from 'vue'
import { RouteLocationRaw, useRouter } from 'vue-router'
import { useStore } from '@web/store'
import PAGE_NAME from '@web/consts/PAGE_NAME'

interface UseBackNavigationOptions {
  // Куда вести, если внутри приложения некуда возвращаться
  // (прямой заход по ссылке без истории навигации в SPA).
  fallback?: RouteLocationRaw
}

/**
 * Корректная навигация «назад».
 *
 * window.history.length ненадёжен: он учитывает все записи истории вкладки,
 * включая переходы с внешних сайтов. Поэтому опираемся на внутреннюю историю
 * SPA (store-модуль router), которая наполняется в router.afterEach и содержит
 * только маршруты приложения — внешние сайты туда не попадают.
 */
function useBackNavigation ({ fallback = { name: PAGE_NAME.HOME } }: UseBackNavigationOptions = {}) {
  const router = useRouter()
  const store = useStore()

  // afterEach добавляет в историю и текущий маршрут, поэтому > 1 означает,
  // что до текущей страницы был ещё один внутренний маршрут.
  const canGoBack = computed(() => store.getters['router/history'].length > 1)

  function goBack () {
    if (canGoBack.value) {
      router.go(-1)
      return
    }
    router.push(fallback)
  }

  return {
    canGoBack,
    goBack
  }
}

export default useBackNavigation
